import React from 'react'
import BlogListing from '../components/BlogListing'
import PageHeader from "../components/PageHeader";

const BlogPage = () => {
  return (
   <>
   
   <PageHeader title="प्रसंग विशेष" path="Blogs" name="blog" />
   <BlogListing></BlogListing> 
   
   </>
 )
}

export default BlogPage